import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@app/core/services';

@Injectable()
export class AuthLinkGuard  {
	constructor(private readonly authService: AuthService, private readonly router: Router) {}

	canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		// if there are params let the API handle the authorization
		if (Object.keys(route.params).length > 0 || Object.keys(route.queryParams).length > 0) {
			return true;
		}

		const canAccessLink = this.authService.canAccessLink(state.url);
		if (!canAccessLink) {
			this.authService.logOut();
		}
		return canAccessLink;
	}
}
